<div class="content-with-stepper-and-title">
        <div class="row">
            <div class="col-4 col-pr-12 col-sm-8 col-md-12">
                <div class="box-title">
                    <p class="sub-title" id="subtitle">
                        {{ screenCopies.title }}<strong>{{ screenCopies.title_bold }}</strong>{{ screenCopies.title_two }} {{screenCopies.titleConector}} {{occupation}}
                    </p>
                </div>
                <div id="steps">
                    <ul class="mt-3">
                      <vcl-list>
                          <li *ngFor="let document of documents" vclListSimple>
                              <span id="iconCheck" class="icon icon-itaufonts_check"></span>
                              <vcl-list-text class="list">
                                  {{document}}
                              </vcl-list-text>
                          </li>
                      </vcl-list>
                  </ul>
                </div>
            </div>
        </div>
    <app-controls id="support-documents" [hasPrevious]="mainButtonBehaviour.previous" [hasNext]="mainButtonBehaviour.next" [nextLabel]="mainButtonBehaviour.label" (next)="next()"></app-controls>
</div>